var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mall-3d-icon",style:({ width: _vm.size + 'px', height: _vm.size + 'px' })},[_c('img',{staticClass:"mall-3d-icon__img",attrs:{"src":_vm.src,"alt":""}}),_vm._v(" "),_c('img',{staticClass:"mall-3d-icon__img mall-3d-icon__img--screen",style:({ opacity: _vm.screenOpacity }),attrs:{"src":_vm.src,"alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ee549c7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/new/atoms/Mall3dIcon.vue
// module id = null
// module chunks = 